import { render, staticRenderFns } from "./Jewel05_Daia.vue?vue&type=template&id=3810cb92&scoped=true&"
import script from "./Jewel05_Daia.vue?vue&type=script&lang=js&"
export * from "./Jewel05_Daia.vue?vue&type=script&lang=js&"
import style0 from "./Jewel05_Daia.vue?vue&type=style&index=0&id=3810cb92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3810cb92",
  null
  
)

export default component.exports